import React, { useState, useEffect } from 'react';
import RangeInputNumber from '../../molecules/Range/RangeInputNumber';
import { GraphDispSetting } from './TrendGraphChart';
import Grid, { GridSpacing } from '@material-ui/core/Grid';
import { useTranslation } from 'react-i18next';

type Props = {
  settingData: GraphDispSetting;
  onChange: (data: GraphDispSetting) => void;
};

const TrendGraphChartSetting: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const buttonStyle = {
    maxWidth: '180px',
    maxHeight: '35px',
    minWidth: '180px',
    minHeight: '35px',
  };
  const yMinMaxOn = (min: number, max: number) => {
    if (min == Infinity) {
      return;
    }
    if (max == Infinity) {
      return;
    }
    console.debug(['yMinMaxOn', `min=${min},max=${max}`]);
    var tmp = props.settingData;
    tmp.yMin = min;
    tmp.yMax = max;
    props.onChange(tmp);
  };

  return (
    <RangeInputNumber
      textBoxWidth={'70px'}
      label={t('TrendGraphChartSetting.グラフ縦軸範囲', 'グラフ縦軸範囲')}
      minValue={props.settingData.yMin}
      maxValue={props.settingData.yMax}
      maxValueLimit={999999}
      minValueLimit={-999999}
      onChange={yMinMaxOn}
    />
  );
};

export default TrendGraphChartSetting;
